export default class KformTabWfController {
	/* @ngInject */
	constructor() {
		this.kform = undefined;
		this.form = undefined;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;
	}
}
